import { Divider } from 'antd';

import {
  IntegrationSectorsList,
  IntegrationsSortList,
  IntegrationStatesList,
} from '@page/integrations/integrations.page-options';
import { FormItem, FormWrapper } from '@page/integrations/integrations.page-style';
import { Select } from '@style/global-style.app';

import { Input } from '@atom/form/input/input';
import { Title } from '@atom/typography/typography';
import { IntegrationCard } from '@component/integration-card/integration-card';
import { SkeletonCards } from '@component/skeleton/skeleton-cards/skeleton-cards';

import { useConsumerIntegrations } from './consumer-integrations.hook';
import { IntegrationsWrapper } from './consumer-integrations.styles';

export const ConsumerIntegrations = () => {
  const { data, isLoading, currentState, contextHolder, setTab, onInput, onSector, onFilter } =
    useConsumerIntegrations();

  return (
    <>
      <Title level={3} weight={400}>
        Connections
      </Title>
      <FormWrapper autoComplete='off' layout='vertical' name='webhook'>
        <FormItem label='Search for connection'>
          <Input
            placeholder='Search by name'
            onChange={({ target }) => onInput(target.value.replace(/\s+/g, ' ').trim())}
          />
        </FormItem>
        <FormItem label='Connection state'>
          <Select options={IntegrationStatesList} value={currentState} onChange={setTab} />
        </FormItem>
        <FormItem label='Sector'>
          <Select defaultValue={null} options={IntegrationSectorsList} onChange={onSector} />
        </FormItem>
        <FormItem label='Sort by name'>
          <Select defaultValue={null} options={IntegrationsSortList} onChange={onFilter} />
        </FormItem>
      </FormWrapper>
      <Divider />
      <IntegrationsWrapper gutter={[16, 16]}>
        {isLoading && <SkeletonCards />}
        {data.map((connection) => (
          <IntegrationCard key={connection.serviceId} connection={connection} currentState={currentState} />
        ))}
      </IntegrationsWrapper>
      {contextHolder}
    </>
  );
};
